__turbopack_context__.v({
  "card": "PromoCard-module-scss-module__qeiiYG__card",
  "description": "PromoCard-module-scss-module__qeiiYG__description",
  "descriptionTruncated": "PromoCard-module-scss-module__qeiiYG__descriptionTruncated",
  "fade-in": "PromoCard-module-scss-module__qeiiYG__fade-in",
  "footer": "PromoCard-module-scss-module__qeiiYG__footer",
  "heading": "PromoCard-module-scss-module__qeiiYG__heading",
  "image": "PromoCard-module-scss-module__qeiiYG__image",
  "no-transform": "PromoCard-module-scss-module__qeiiYG__no-transform",
  "price": "PromoCard-module-scss-module__qeiiYG__price",
  "priceOld": "PromoCard-module-scss-module__qeiiYG__priceOld",
  "priceValue": "PromoCard-module-scss-module__qeiiYG__priceValue",
  "rotate": "PromoCard-module-scss-module__qeiiYG__rotate",
});
